import {SmallLoader} from '@kit';

import React from 'react';

import {Image, useMonsterQuery, ImageTarget} from '../../../generated/types';
import {getApolloError} from '../../../components/utils';
import {EditHoc} from '../../../components/edit-hoc';
import {Markdown} from '../../../components/utils/md';
import {toMonsterEnvironments, toMonsterTreasure} from '../../../components/render-helpers';
import {Gallery} from '../../../components/gallery';
import {CommentTargetType, Comments} from '../../../components/comments';
import {RuleExcerpts} from '../../../components/rule-excerpts';

import pageCss from '../../../components/common.module.css';

type Props = {
	monsterId: string;
};

export const MonsterAbout: React.FC<Props> = ({monsterId}) => {
	const {data, loading, error} = useMonsterQuery({variables: {id: monsterId}});
	const monster = data?.monster;

	return (
		<>
			{loading && (
				<div className={pageCss.fullSizeBlock}>
					<SmallLoader />
				</div>
			)}
			{error && <div className={pageCss.fullSizeBlock}>{getApolloError(error).message}</div>}

			{monster && (
				<div>
					<RuleExcerpts excerpts={monster.ruleExcerpts} headings />

					{monster.group && (
						<React.Fragment key={monster.group.id}>
							<h2>{monster.group.title}</h2>
							<div>
								<i>{monster.group.about}</i>
							</div>
							<div>
								{monster?.group?.environment && (
									<>
										<b>Среда обитания:</b> {toMonsterEnvironments(monster.group.environment)}
										{monster.group.treasure && '; '}
									</>
								)}
								{monster?.group?.treasure && (
									<>
										<b>Сокровища:</b> {toMonsterTreasure(monster.group.treasure)}
									</>
								)}
							</div>
							<EditHoc
								load={() => import('../edit-buttons').then((m) => m.EditMonsterGroup)}
								editProps={{id: monster.group.id, monsterId: monster.id}}
							>
								<Markdown text={monster.group.description || ''} />
							</EditHoc>
						</React.Fragment>
					)}
					{monster.description && (
						<>
							<h2>{monster.title}</h2>
							<EditHoc
								load={() => import('../edit-buttons').then((m) => m.EditMonsterDescription)}
								editProps={{id: monster.id}}
							>
								<Markdown text={monster.description} />
							</EditHoc>
						</>
					)}
					{monster.lairTraits && monster.monsterLair && monster.monsterLair.description && (
						<>
							<h2>{monster.monsterLair.title}</h2>
							<Markdown
								text={monster.monsterLair.description}
								payload={{lairTraits: monster.lairTraits, monster}}
							/>
						</>
					)}
					<Gallery
						images={(monster.images || []) as Image[]}
						title="Галерея"
						target={{type: ImageTarget.Monster, id: monsterId}}
					/>
					{monster.legacyDescriptions && (
						<div>
							{monster.legacyDescriptions
								.filter((obj) => obj.title && obj.description)
								.map((obj) => (
									<div key={obj.id}>
										<h2>{obj.title}</h2>
										<Markdown text={obj.description!} />
									</div>
								))}
						</div>
					)}
				</div>
			)}
			{monster && <Comments targetType={CommentTargetType.Monster} targetId={monsterId} />}
		</>
	);
};
